!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.progressEl = this.querySelector("[data-progress]");
    }
    connectedCallback() {
      this.updateProgress();
    }
    updateProgress() {
      const t = Number(this.getAttribute("data-current")), e = Number(this.getAttribute("data-total"));
      if (!this.progressEl || !t || !e) return;
      const s = t / e * 100;
      this.progressEl.style.setProperty("--progress", `${s}%`);
    }
  }
  customElements.get("pagination-progress") || customElements.define("pagination-progress", t);
}();